import React from 'react';
import { removeStorage } from './../../utils';
import CONSTANT from './../../constant';
class Logout extends React.Component<any, any> {

    componentDidMount() {
        document.title = 'Logout';

        removeStorage('rsc_cache')
        // remove all storage keys except language
        removeStorage(CONSTANT.key.token);
        removeStorage(CONSTANT.key.userDetail);
        removeStorage(CONSTANT.key.permission);
        localStorage.clear();

        window.location.href = '/';
    }

    public render() {
        return (
            <React.Fragment>
                <div className="text-center">Redirecting to home page</div>
            </React.Fragment>
        );
    }
}

export default Logout;